let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Apgs")).then(() => parcelRequire('bkQi0'));